"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAllCookies = exports.utils = void 0;
const query_string_1 = __importDefault(require("query-string"));
exports.utils = {
    serialize: (form) => {
        const data = {};
        // eslint-disable-next-line no-restricted-syntax
        for (const field in form) {
            if (form[field].value !== undefined) {
                switch (field) {
                    case 'phone':
                        data[field] = form[field].value.replace(/\s/g, '');
                        break;
                    default:
                        data[field] = form[field].value;
                }
                if (form[field].validator && (form[field].validator.min_value || form[field].validator.max_value)) {
                    data[field] = form[field].value && Number(form[field].value);
                }
            }
        }
        return data;
    },
    // fillForm: (form: any, data: any, property = 'value') => {
    //     // eslint-disable-next-line no-restricted-syntax
    //     for (const field of form) {
    //         if (data[field] !== undefined && form[field][property] !== undefined) {
    //             switch (field) {
    //                 case 'radius':
    //                 case 'status':
    //                 case 'id':
    //                     form[field][property] = data[field] && Number(data[field])
    //                     break
    //
    //                 case 'discount':
    //                     form[field][property] = !!data[field]
    //                     break
    //
    //                 case 'pickup':
    //                     // eslint-disable-next-line eqeqeq
    //                     form[field][property] = data[field] == 'true'
    //                     break
    //
    //                 default:
    //                     form[field][property] = data[field]
    //             }
    //         }
    //     }
    // },
    toCssStyle: (string) => string.toLowerCase().replace(/\s/g, '-'),
    // typing: (object: any) => {
    //     const result: any = {}
    //     for (const prop in object) {
    //         const item = object[prop]
    //         switch (prop) {
    //             case 'radius':
    //             case 'status':
    //             case 'id':
    //             case 'page':
    //             case 'amount':
    //                 result[prop] = item && Number(item)
    //                 break
    //
    //             default:
    //                 result[prop] = item
    //         }
    //     }
    //     return result
    // },
    setRequiredFields: (form, fields, label) => {
        fields.forEach((field) => {
            if (form[field]) {
                // eslint-disable-next-line no-param-reassign
                form[field].validator = { ...form[field].validator, required: true };
                // eslint-disable-next-line eqeqeq
                if (label && form[field].label) {
                    // eslint-disable-next-line no-param-reassign
                    form[field].label += '*';
                }
            }
        });
    },
    convertNumberToDecimal(numb, zeroCount) {
        let value = 0.0;
        const zero = zeroCount || 2;
        if (typeof numb === 'number') {
            value = Number(numb.toFixed(zero));
        }
        else if (typeof numb === 'string') {
            // eslint-disable-next-line no-param-reassign
            numb = parseInt(numb, 10);
            value = numb.toFixed(zero);
        }
        return value;
    },
    pluralize: (count, noun, suffix = 's') => `${count} ${noun}${count !== 1 ? suffix : ''}`,
    encodeRouteFilters: (filters) => (filters ? btoa(query_string_1.default.stringify(filters)) : null),
    decodeRouteFilters: (string) => (string ? query_string_1.default.parse(atob(string)) : {}),
    isFiltersEmpty: (filters) => {
        const defaultFilters = ['page', 'sort', 'per-page'];
        let result = true;
        // eslint-disable-next-line no-restricted-syntax
        for (const key in filters) {
            if (!defaultFilters.includes(key) && filters[key]) {
                result = false;
            }
        }
        return result;
    },
    money: (value) => parseFloat(value).toFixed(2).replace(',', '.'),
    moneyCent: (value) => parseFloat(value).toFixed(3).replace(',', '.'),
    hideAddress: (address) => {
        const [a, city, zip, b, c] = (address || '-,-,-,-').split(',');
        return city === '-' ? '-' : `${city}, ${zip}`;
    },
    hideEntity(entity) {
        const symbols = this.repeat(' *', entity.length / 2);
        return entity && entity.length >= 3 ? symbols : '**';
    },
    repeat: (text, times) => {
        let result = '';
        while (times > 0) {
            // eslint-disable-next-line no-param-reassign
            times -= 1;
            result += text;
        }
        return result;
    },
    isNewBankRequisites(account_number, routing_number) {
        const emptyNumberValues = [null, 'xxxxxxxxx'];
        const isNewNumbers = !emptyNumberValues.includes(account_number) || !emptyNumberValues.includes(routing_number);
        return isNewNumbers;
    },
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    fillServices: (services = []) => {
        const data = {
            unitiesList: [],
            featuresList: [],
            deliveryList: [],
            serviceFeaturesByGroup: {},
        };
        services.forEach((item) => {
            // eslint-disable-next-line eqeqeq
            if (item.unity != undefined) {
                const code = item.unity.id;
                // eslint-disable-next-line eqeqeq
                if (!data.unitiesList?.some((unity) => unity.code === code)) {
                    data.unitiesList.push({
                        name: item.unity.name,
                        value: item.unity.id,
                        code: item.unity.id,
                        days_related: item.unity.days_related,
                        code_name: item.unity.code_name,
                        list: services.filter((sr) => sr?.unity?.id === item?.unity?.id && sr.type.code_name === 'SERVICE'),
                    });
                }
            }
        });
        data.featuresList = services
            .filter((item) => item.type.code_name === 'FEATURE' && item.group === 0)
            .map((item) => ({ name: item.title, code: item.code }));
        data.deliveryList = services
            .filter((item) => item.type.code_name === 'DELIVERY')
            .map((item) => ({ name: item.title, value: item.code, group: item.group }));
        data.serviceFeaturesByGroup = services
            .filter((item) => item.type.code_name === 'FEATURE' && item.group !== 0)
            .reduce((acc, item) => {
            if (!acc[item.group]) {
                acc[item.group] = [];
            }
            acc[item.group].push({ name: item.title, code: item.code });
            return acc;
        }, {});
        return data;
    },
    getDefaultServiceIcon(serviceName) {
        return (serviceName && serviceName.replace('-', '').split(' ')[0].toLowerCase()) || '';
    },
    getSearchParamByName(search, name) {
        const params = new URLSearchParams(search);
        return params.get(name);
    },
    sortServicesByActivity(services) {
        // TODO: needs to be done
        return services;
    },
    isElementInViewport(el, checkCorners = true) {
        const rect = el.getBoundingClientRect();
        const vWidth = window.innerWidth || document.documentElement.clientWidth;
        const vHeight = window.innerHeight || document.documentElement.clientHeight;
        const efp = (x, y) => document.elementFromPoint(x, y);
        // Return false if it's not in the viewport
        if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight)
            return false;
        // Return true if any of its four corners are visible
        return (!checkCorners ||
            el.contains(efp(rect.left, rect.top)) ||
            el.contains(efp(rect.right, rect.top)) ||
            el.contains(efp(rect.right, rect.bottom)) ||
            el.contains(efp(rect.left, rect.bottom)));
    },
};
const deleteAllCookies = () => {
    const cookies = document.cookie.split(';');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
};
exports.deleteAllCookies = deleteAllCookies;
